import { EnumUserPermission } from "@/app/services/generated/enums/enumUserPermission.generated";
import { MenuItem } from "@/app/ui/navigation/types";
import type { Location } from "vue-router";
import { parseEnumArrayQuery } from "@/app/ui/navigation/queryHelpers";

export const unauthorisedPath = "/unauthorised" as const;

export const unauthorisedMenu = {
  landing: "unauthorised",
  landingLocation: (opts: {
    requiredPermissions: EnumUserPermission[];
  }): Location => ({
    name: unauthorisedMenu.landing,
    query: {
      requiredPermissions: opts.requiredPermissions.map((permission) =>
        permission.key.toString()
      ),
    },
    path: unauthorisedPath,
  }),
};

export const buildUnauthorisedItems: () => MenuItem[] = () => [
  MenuItem.fromOpts({
    name: unauthorisedMenu.landing,
    url: unauthorisedPath,
    view: (): Promise<any> =>
      import(/* webpackChunkName */ "@/components/pages/Unauthorised.vue"),
    visible: false,
    componentProps: (route) => ({
      requiredPermissions: parseEnumArrayQuery(
        route.query.requiredPermissions,
        EnumUserPermission
      ),
    }),
  }),
];
